import React from 'react';
import { Byline, Heading, StyledCaption, Subheading } from './Caption.styles';
import { TYPES } from '../../../typography/PlayText/PlayText';

const Caption = ({ byline, heading, type, subHeading }) => (
    <StyledCaption>
        {byline && (
            <Byline type="medium" as="span">
                {byline}
            </Byline>
        )}
        {heading && <Heading as="h2">{heading}</Heading>}

        {subHeading && <Subheading type={TYPES.LARGE}>{subHeading}</Subheading>}
    </StyledCaption>
);

export default Caption;
